import { jsx } from "react/jsx-runtime";
import Select from "react-select";
import { selectComponents, styles } from "./components.mjs";
import { fixedForwardRef } from "../../utils/fixedForwardRef.mjs";
import { useRef, useEffect } from "react";
function BaseSelectInner(props, ref) {
  const {
    fieldProps,
    value,
    onChange,
    options,
    onBlur,
    onFocus,
    name,
    placeholder,
    disabled,
    isReadOnly,
    isMulti,
    autoFocus,
    searchable,
    clearable = false
  } = props;
  const menuPortalTarget = useRef();
  useEffect(() => {
    if (!menuPortalTarget.current) {
      menuPortalTarget.current = document.createElement("div");
    }
    document.body.appendChild(menuPortalTarget.current);
    return () => {
      if (document.body.contains(menuPortalTarget.current)) {
        document.body.removeChild(menuPortalTarget.current);
      }
    };
  }, [menuPortalTarget]);
  return /* @__PURE__ */ jsx(
    Select,
    {
      id: fieldProps.id,
      name,
      "aria-label": fieldProps["aria-label"],
      "aria-labelledby": fieldProps["aria-labelledby"],
      isDisabled: disabled,
      isReadOnly: isReadOnly || false,
      autoFocus,
      value: isMulti ? options.filter((o) => (value ?? []).includes(o.value)) : options.find((o) => o.value === value),
      onChange: (o) => {
        if (isMulti) {
          const multiValue = o;
          onChange(multiValue.map((a) => a.value));
        } else {
          const singleValue = o;
          if (clearable) {
            onChange(singleValue == null ? void 0 : singleValue.value);
          } else if (singleValue != null) {
            onChange(singleValue.value);
          }
        }
      },
      onBlur,
      onFocus,
      options: options.slice().sort((a, b) => {
        if (isMulti) {
          const selectedValues = value ?? [];
          const isSelected = (s) => selectedValues.includes(s.value);
          if (isSelected(a) && !isSelected(b)) {
            return -1;
          }
          if (!isSelected(a) && isSelected(b)) {
            return 1;
          }
        }
        return 0;
      }),
      placeholder,
      components: selectComponents,
      openMenuOnFocus: true,
      classNames: {
        control: () => fieldProps.className
      },
      styles: styles(),
      menuPortalTarget: menuPortalTarget.current,
      isMulti,
      isClearable: false,
      ref,
      multiValueMessage: props.isMulti && (!props.multiSelectMode || props.multiSelectMode === "summary") ? props.multiValueMessage : void 0,
      closeMenuOnSelect: !isMulti,
      hideSelectedOptions: false,
      menuIsOpen: isReadOnly ? false : void 0,
      isSearchable: isReadOnly ? false : searchable ?? true,
      showMultiSelectBulkActions: isMulti ? props.showMultiSelectBulkActions : false,
      clearAllButtonLabel: isMulti ? props.clearAllButtonLabel : void 0,
      selectAllButtonLabel: isMulti ? props.selectAllButtonLabel : void 0,
      multiSelectMode: isMulti ? props.multiSelectMode : void 0
    }
  );
}
const BaseSelect = fixedForwardRef(BaseSelectInner);
export {
  BaseSelect
};
